export default "__VITE_ASSET__Bh36XzBL__"